<template>
  <BaseChannelPieChart
    :title="title"
    :item-id="itemId"
    v-bind="$attrs"
  />
</template>

<script>
import BaseChannelPieChart from '@/components/cards/BaseChannelPieChart';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropChannelPieChart',
  components: {
    BaseChannelPieChart,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
